/*
 * product-form.js — Damų Kampelis (Dawn variantas)
 * Pakeitimas 2026-09-24: kai cart_type = "page", prekė pridedama per AJAX,
 * atnaujinama krepšelio ikonėlė ir parodomas popup'as (kaip AI Collection
 * blokuose) — klientas lieka produkto puslapyje, jokio peradresavimo į /cart.
 * Krepšelio ikonėlės paspaudimas ir toliau veda į /cart (Parcelly pastomatų pasirinkimas).
 *
 * Pakeitimas 2026-09-24 (2): jei prekė pridedama pačiame /cart puslapyje (pvz. per
 * AKCIJOS quick-add), krepšelis atnaujinamas be perkrovimo — tuo pačiu Dawn mechanizmu,
 * kurį naudoja Essential Upsell (cart-items.getSectionsToRender()): perpiešiamos tik
 * prekių sąrašo ir sumos (.js-contents) dalys, Parcelly widget'as neliečiamas.
 */

/* ---------- DK: /cart puslapio atnaujinimas be perkrovimo (bendras su AI Tabs bloku) ---------- */
window.dkCartPageSections =
  window.dkCartPageSections ||
  function () {
    const ci = document.querySelector('cart-items');
    if (!ci || typeof ci.getSectionsToRender !== 'function') return null;
    return ci.getSectionsToRender().map((s) => s.section);
  };

window.dkRefreshCartPage =
  window.dkRefreshCartPage ||
  function (response) {
    const ci = document.querySelector('cart-items');
    if (!ci || typeof ci.getSectionsToRender !== 'function' || !response || !response.sections) return false;
    ci.getSectionsToRender().forEach((s) => {
      const host = document.getElementById(s.id);
      const html = response.sections[s.section];
      if (!host || !html) return;
      const target = host.querySelector(s.selector) || host;
      target.innerHTML = ci.getSectionInnerHTML(html, s.selector);
    });
    ci.classList.remove('is-empty');
    const footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.remove('is-empty');
    return true;
  };

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const dkCroSource = this.form.dataset.dkCroSource === 'sticky'
          ? 'sticky'
          : (this.closest('product-info[id^="MainProduct-"]') ? 'main' : 'quickadd');
        let dkCroHttpOk = false;
        let dkCroSettled = false;
        const dkCroTrack = (outcome) => {
          try { window.dkCroMeasurement?.track(outcome, dkCroSource); } catch (_) {}
        };
        dkCroTrack('attempt');

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          // DK: cart_type = "page" — /cart puslapyje prašome krepšelio sekcijų, kitur tik ikonėlės
          formData.append('sections', window.dkCartPageSections() || 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            dkCroHttpOk = response.ok;
            return response.json();
          })
          .then((response) => {
            const dkCroItems = Array.isArray(response?.items) ? response.items : [response];
            const dkCroConfirmed = dkCroHttpOk && !response?.status &&
              dkCroItems.length > 0 && dkCroItems.every((item) =>
                item && Number(item.id) > 0 && Number(item.quantity) > 0
              );
            dkCroSettled = true;
            dkCroTrack(dkCroConfirmed ? 'success' : 'failure');
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // DK: vietoj window.location = /cart — tylus pridėjimas
              this.dkRenderCartIcon(response);
              this.error = false;
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: response } }));

              // DK: /cart puslapyje — atnaujiname prekių sąrašą ir sumą be perkrovimo
              window.dkRefreshCartPage(response);

              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) quickAddModal.hide(true);

              this.dkShowPopup(response);
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            if (!dkCroSettled) {
              dkCroSettled = true;
              dkCroTrack('failure');
            }
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      /* ---------- DK: krepšelio ikonėlės atnaujinimas ---------- */
      dkRenderCartIcon(response) {
        const html = response.sections && response.sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('.shopify-section') || parsed.body;
        bubble.innerHTML = source.innerHTML;
      }

      /* ---------- DK: popup "Įdėta į krepšelį" (v2, 2026-10-05) ----------
       * Neišnyksta pats ne krepšelio puslapyje: lieka, kol klientas paspaudžia
       * "Peržiūrėti krepšelį", "Tęsti apsipirkimą", ✕ arba Esc.
       * /cart puslapyje — kaip anksčiau, trumpas pranešimas be mygtukų (4 s).
       */
      dkPopupTitle(item) {
        let title = item.product_title || item.title || '';
        if (item.variant_title && item.variant_title !== 'Default Title' && !item.product_has_only_default_variant) {
          title += ' – ' + item.variant_title;
        }
        return title;
      }

      dkResetQuantity() {
        const formId = this.form && this.form.getAttribute('id');
        const inputs = new Set();
        if (formId) document.querySelectorAll(`input[name="quantity"][form="${formId}"]`).forEach((i) => inputs.add(i));
        this.form.querySelectorAll('input[name="quantity"]').forEach((i) => inputs.add(i));
        inputs.forEach((input) => {
          const min = parseInt(input.dataset.min || input.min || '1', 10) || 1;
          if (String(input.value) !== String(min)) {
            input.value = min;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      dkShowPopup(item) {
        const title = typeof item === 'string' ? item : this.dkPopupTitle(item);
        const onCartPage = !!document.querySelector('cart-items');
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

        if (!document.getElementById('dk-atc-popup-style-v2')) {
          const style = document.createElement('style');
          style.id = 'dk-atc-popup-style-v2';
          style.textContent = `
            .dk-atc-popup{position:fixed;bottom:20px;right:20px;z-index:9999;width:340px;max-width:calc(100vw - 32px);
              background:#fff;color:#222;border-radius:14px;box-shadow:0 8px 28px rgba(0,0,0,.22);
              border-top:4px solid #DF3266;padding:16px 16px 14px;font-family:Poppins,sans-serif;font-size:14px;line-height:1.4;
              opacity:0;visibility:hidden;transform:translateY(24px);transition:opacity .3s ease,transform .3s ease,visibility .3s;pointer-events:none}
            .dk-atc-popup.show{opacity:1;visibility:visible;transform:translateY(0);pointer-events:auto}
            .dk-atc-popup__head{display:flex;align-items:flex-start;gap:10px;padding-right:22px}
            .dk-atc-popup__icon{width:22px;height:22px;flex-shrink:0;color:#fff;background:#2e9e5b;border-radius:50%;padding:3px;box-sizing:border-box}
            .dk-atc-popup__label{font-weight:600;color:#2e9e5b;margin:0}
            .dk-atc-popup__title{margin:2px 0 0;color:#222;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
            .dk-atc-popup__summary{margin:8px 0 0 32px;color:#666;font-size:13px}
            .dk-atc-popup__close{position:absolute;top:10px;right:10px;width:28px;height:28px;border:0;background:transparent;
              color:#888;font-size:22px;line-height:28px;cursor:pointer;padding:0}
            .dk-atc-popup__btn{display:block;width:100%;box-sizing:border-box;margin-top:12px;padding:13px 16px;border-radius:10px;
              background:#DF3266;color:#fff !important;text-align:center;font-weight:600;font-size:15px;text-decoration:none}
            .dk-atc-popup__btn:hover{background:#c92a5a}
            .dk-atc-popup__continue{display:block;width:100%;margin-top:8px;padding:8px;border:0;background:transparent;
              color:#B81E4F;font-weight:600;font-size:14px;text-decoration:underline;text-underline-offset:3px;cursor:pointer}
            .dk-atc-popup--compact .dk-atc-popup__close,.dk-atc-popup--compact .dk-atc-popup__btn,
            .dk-atc-popup--compact .dk-atc-popup__continue,.dk-atc-popup--compact .dk-atc-popup__summary{display:none}
            @media screen and (max-width:749px){
              .dk-atc-popup{left:16px;right:16px;bottom:16px;width:auto;max-width:none}
            }`;
          document.head.appendChild(style);
        }

        let popup = document.getElementById('dk-atc-popup');
        if (!popup) {
          popup = document.createElement('div');
          popup.id = 'dk-atc-popup';
          popup.className = 'dk-atc-popup';
          popup.setAttribute('role', 'dialog');
          popup.setAttribute('aria-live', 'polite');
          popup.setAttribute('aria-label', 'Prekė įdėta į krepšelį');
          popup.innerHTML =
            '<button type="button" class="dk-atc-popup__close" aria-label="Uždaryti">×</button>' +
            '<div class="dk-atc-popup__head">' +
            '<svg class="dk-atc-popup__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
            '<div><p class="dk-atc-popup__label">Įdėta į krepšelį</p><p class="dk-atc-popup__title"></p></div>' +
            '</div>' +
            '<p class="dk-atc-popup__summary"></p>' +
            '<a class="dk-atc-popup__btn" href="' + cartUrl + '">Peržiūrėti krepšelį</a>' +
            '<button type="button" class="dk-atc-popup__continue">Tęsti apsipirkimą</button>';
          document.body.appendChild(popup);

          const hide = () => popup.classList.remove('show');
          popup.querySelector('.dk-atc-popup__close').addEventListener('click', hide);
          popup.querySelector('.dk-atc-popup__continue').addEventListener('click', hide);
          document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(); });
          const keepOpen = () => clearTimeout(ProductForm.dkPopupTimer);
          popup.addEventListener('pointerenter', keepOpen);
          popup.addEventListener('touchstart', keepOpen, { passive: true });
          popup.addEventListener('focusin', keepOpen);
        }

        popup.classList.toggle('dk-atc-popup--compact', onCartPage);
        popup.querySelector('.dk-atc-popup__title').textContent = title;
        const summary = popup.querySelector('.dk-atc-popup__summary');
        summary.textContent = '';

        popup.classList.remove('show');
        void popup.offsetWidth;
        popup.classList.add('show');

        clearTimeout(ProductForm.dkPopupTimer);
        if (onCartPage) {
          ProductForm.dkPopupTimer = setTimeout(() => popup.classList.remove('show'), 4000);
        } else {
          ProductForm.dkPopupTimer = setTimeout(() => popup.classList.remove('show'), 10000);
          fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js')
            .then((r) => r.json())
            .then((cart) => {
              const fmt = new Intl.NumberFormat('lt-LT', { style: 'currency', currency: cart.currency || 'EUR' });
              const n = cart.item_count;
              const word = n % 10 === 1 && n % 100 !== 11 ? 'prekė' : (n % 10 === 0 || (n % 100 >= 11 && n % 100 <= 19) ? 'prekių' : 'prekės');
              summary.textContent = `Krepšelyje: ${n} ${word} · ${fmt.format(cart.total_price / 100)}`;
            })
            .catch(() => {});
        }

        this.dkResetQuantity();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

